<ng-container *cidContentLoader="contentLoading">
        <h1>{{ 'DEVICE_CODE_FLOW.CODE_INIT.DEVICE_CODE' | translate }}</h1>
        <p>{{'DEVICE_CODE_FLOW.CODE_INIT.ENTER_CODE_DEVICE' | translate}}
        </p>
        <app-input-group [options]="inputGroupOption" (btnEvent)="submit()"
            (inputEvent)="userCode = $event" [inputLoading]="verifyInProgress">
        </app-input-group>
        <div class="mat-error">
            {{ errorMessage | translate }}
        </div>
</ng-container>
